import { Model } from './model'

export class Entity extends Model {
  name: string
  options: any
  type: string

  constructor(obj = {}) {
    super(obj)
  }
}
